import * as React from "react"
export const EmailIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#a)' fill='currentColor'>
      <path d='M11.671 12.254a3 3 0 0 1-3.342 0L.133 6.79A3 3 0 0 1 0 6.695v8.953a1.84 1.84 0 0 0 1.841 1.842H18.16A1.84 1.84 0 0 0 20 15.647V6.695a3 3 0 0 1-.134.095z' />
      <path d='m.783 5.815 8.196 5.464a1.84 1.84 0 0 0 2.042 0l8.196-5.464c.49-.327.783-.874.783-1.464 0-1.015-.826-1.84-1.84-1.84H1.84A1.84 1.84 0 0 0 0 4.352c0 .59.293 1.136.783 1.463' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
)
